import styled from 'styled-components';

export const DisabledSavePasswordInputStyled = styled.input`
  display: none;
`;
